import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

const backendEndpointMap = {
  'https://dad.accountedfor.com.au':
    'https://startcompanies-api.utrffqq94dtco.ap-southeast-2.cs.amazonlightsail.com',
  'http://localhost:3002': 'http://localhost:3001',
}

export const backendEndpoint = backendEndpointMap[window.origin]
